<template>
    <modal id="delivery-action-modal"
           v-model="showModal"
           :loading="loading"
           :preloader="preloader" :title="generateModalTitle('delivery details')"
           @input="closeModal"
           @submit="submitData">

        <form
            ref="form"
            :data-url='SAVE_ORDER_DELIVERY+orderId' @submit.prevent="submitData">

            <div class="row">

                <div class="col-6">
                    <div class="mb-3">
                        <app-form-group v-if="isAdmin" type="date" v-model="formData.targetDate" :label="$t('Target Date')"
                :placeholder="$placeholder($t('Target Date'))" />
                        <template v-else>
                            <label class="form-label">{{ $t('Target Date') }}</label>
                            <input type="text" class="form-control" :value="formatDate(formData.targetDate)" readonly disabled />
                        </template>
                    </div>
                </div>

                <div class="col-6">
                    <div class="mb-3">
                        <app-form-group type="date" v-model="formData.revisedTargetDate" :min-date="formData.targetDate ? formData.targetDate : todayDate"
                :label="$t('Revised Target Date')" :placeholder="$placeholder($t('Revised Target Date'))" />
                    </div>
                </div>

                <div class="col-6">
                    <div class="mb-3 d-flex align-items-end">
                        <app-form-group class="flex-grow-1 mb-0" type="date" v-model="formData.readyDate" :label="$t('Ready Date')"
                :placeholder="$placeholder($t('Ready Date'))" />
                        <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="setToday('readyDate')">{{ $t('Today') }}</button>
                    </div>
                </div>

                <div class="col-6">
                    <div class="mb-3">
                        <label class="form-label">{{ $t('Delay (days)') }}</label>
                        <input type="text" class="form-control" :value="delayDays" readonly
                            :placeholder="$t('Auto')" />
                    </div>
                </div>

                <div class="col-6">
                    <div class="mb-3 d-flex align-items-end">
                        <app-form-group class="flex-grow-1 mb-0" type="date" v-model="formData.patientInformedDate" :label="$t('Patient Informed Date')"
                :placeholder="$placeholder($t('Patient Informed Date'))" />
                        <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="setToday('patientInformedDate')">{{ $t('Today') }}</button>
                    </div>
                </div>

                <div class="col-6">
                    <div class="mb-3">
                        <label for="deliveryMode" class="form-label">{{ $t('Delivery Mode') }}</label>
                        <app-input type="select" :list="deliveryModeOptions" list-value-field="name"
                                v-model="formData.deliveryMode" :required="false" :placeholder="$placeholder('Delivery Mode')" />
                    </div>
                </div>

                <!-- Collect at Clinic -->
                <div class="col-6" v-if="isCollect">
                    <div class="mb-3 d-flex align-items-end">
                        <app-form-group class="flex-grow-1 mb-0" type="date" v-model="formData.collectionDate" :label="$t('Collection Date')"
                :placeholder="$placeholder($t('Collection Date'))" />
                        <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="setToday('collectionDate')">{{ $t('Today') }}</button>
                    </div>
                </div>

                <!-- Dispatch to Patient -->
                <template v-if="isDispatch">
                    <div class="col-6">
                        <div class="mb-3 d-flex align-items-end">
                            <app-form-group class="flex-grow-1 mb-0" type="date" v-model="formData.dispatchDate" :label="$t('Dispatch Date')"
                    :placeholder="$placeholder($t('Dispatch Date'))" />
                            <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="setToday('dispatchDate')">{{ $t('Today') }}</button>
                        </div>
                    </div>
                </template>

            </div>
        </form>

    </br></br></br></br></br></br>
    </modal>

</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import { SAVE_ORDER_DELIVERY, SELECTABLE_DROPDOWN, GENERATE_ORDER_INVOICE } from "../../../../Config/ApiUrl-CP";
import {axiosGet, axiosPost, urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import { numberWithCurrencySymbol } from "../../../../Helper/Helper";

export default {
    name: "DeliveryActionModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        orderId: {
            require: true
        },
        edititeminfo:{}
    },
    data() {
        return {
            numberWithCurrencySymbol,
            SAVE_ORDER_DELIVERY,
            showNote: true,
            loading: false,
            totalAmt: 0,
            formData: {
                qualitycheck: 0,
                isEdit: this.edititeminfo?.order_product_delivery_details?true:false,
                orderDeliveryId: this.edititeminfo?.order_product_delivery_details?this.edititeminfo?.order_product_delivery_details.id:0,
                order_product_id: this.edititeminfo?.id??0,
                targetDate: '',
                revisedTargetDate: '',
                readyDate: '',
                patientInformedDate: '',
                deliveryMode: '',
                collectionDate: '',
                dispatchDate: '',
            },
            todayDate: new Date(),
            qualityCheckOptions: [],
            deliveryModeOptions: [
                { id: '', name: this.$t('Select Delivery Mode') },
                { id: 'Collect at Clinic', name: this.$t('Collect at Clinic') },
                { id: 'Dispatch to Patient', name: this.$t('Dispatch to Patient') },
            ],
        }
    },
    computed: {
        isAdmin() {
            const roles = (window.user && window.user.roles) ? window.user.roles : [];
            return roles.some(r => ['Super Admin', 'App Admin'].includes(r.name) || r.id === 1);
        },
        isCollect() {
            return this.formData.deliveryMode === 'Collect at Clinic';
        },
        isDispatch() {
            return this.formData.deliveryMode === 'Dispatch to Patient';
        },
        delayDays() {
            const target = this.formData.revisedTargetDate || this.formData.targetDate;
            const ready = this.formData.readyDate;
            if (!target || !ready) return '';
            const t = new Date(this.formatDate(target));
            const r = new Date(this.formatDate(ready));
            if (isNaN(t) || isNaN(r)) return '';
            const diff = Math.round((r - t) / (1000 * 60 * 60 * 24));
            return diff; // positive => ready after target (delayed)
        }
    },
    methods: {
        getQualityCheckOptions() {
            try {
                axiosGet(`${SELECTABLE_DROPDOWN}?list_id=15`).then(response => {
                    this.qualityCheckOptions.push({
                        id: 0,
                        value: 'None',
                    });
                    for (let item of response.data.data) {
                        this.qualityCheckOptions.push({
                            id: item.id,
                            value: item.item_label,
                        });
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        setToday(field) {
            this.formData[field] = this.formatDate(new Date());
        },
        formatDate(dateObj) {
            if(dateObj != '' && dateObj != '0000-00-00' && dateObj != null) {
                dateObj = new Date(dateObj);
                const date = {year: dateObj.getFullYear(), month: dateObj.getMonth() + 1, day: dateObj.getDate()}
                return `${date.year}-${date.month <= 9 ? '0' : ''}${date.month}-${date.day <= 9 ? '0' : ''}${date.day}`;
            }
            return '';
        },
        submitData() {
            const self = this;
            const dateKeys = ['targetDate', 'revisedTargetDate', 'readyDate', 'patientInformedDate', 'collectionDate', 'dispatchDate'];
            Object.entries(this.formData).forEach(function([key, value]) {
                if(dateKeys.includes(key) && value != null) {
                    value = self.formatDate(value);
                }
                self.formData[key] = value;
            });
            this.fieldStatus.isSubmit = true;
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.save(this.formData);
        },
        afterSuccess({data}) {
            $('#delivery-action-modal').modal('hide');
            this.$emit('input', false);
            this.formData = {};

            // Once all items are delivered the backend auto-completes the order and
            // silently dates + numbers the final invoice. Surface a reminder if a
            // balance is still due.
            if (data && (data.order_completed || data.invoice_generated)) {
                let msg = this.$t('All items delivered: order marked Completed and final invoice generated.');
                if (data.balance_due > 0) {
                    msg += ' ' + this.$t('Balance due') + ' ₹' + data.balance_due + ' — ' + this.$t('please collect it from the patient.');
                    this.$toastr.w('', msg);
                } else {
                    this.$toastr.s('', msg);
                }
            } else {
                this.$toastr.s('', data.message);
            }

            setTimeout(() => {
                window.location.reload();
            }, 1500);
        },
        closeModal(eventData) {
            if (eventData) return;
            this.$emit('modal-close');
        }
    },
    mounted() {

    },
    created() {
        this.getQualityCheckOptions();
        const d = this.edititeminfo?.order_product_delivery_details;
        if(d?.id > 0) {
            this.formData.targetDate = d.target_date;
            this.formData.revisedTargetDate = d.revised_target_date;
            this.formData.readyDate = d.ready_date;
            this.formData.patientInformedDate = d.patient_informed_date;
            this.formData.deliveryMode = d.delivery_mode;
            this.formData.collectionDate = d.collection_date;
            this.formData.dispatchDate = d.dispatch_date;
            this.formData.qualitycheck = d.qualityid;
        }
    }
}
</script>
